import React, { Fragment, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, Label, Row } from 'reactstrap';
import Select from "react-select";
import { Country } from "country-state-city";
import { H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { addZone } from '../../../CommonURL';
import { postDataWithToken } from '../../../Utils/restUtils';
import { toast } from 'react-toastify';

const ZoneForm = () => {
    const schema = Yup
        .object()
        .shape({
            name: Yup.string().required(),
            countries: Yup.array().min(1, 'Please select at least one country').required(),
        })
        .required();
    const { register, handleSubmit, control, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    
    const [loading, setLoading] = useState(false);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const navigate = useNavigate();

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            name: data.name,
            countries: data.countries.map(c => c.isoCode),
        };
        const addZoneResponse = await postDataWithToken(addZone, postRequest);
        if (addZoneResponse.data.status === true) {
            toast.success(addZoneResponse.data.message);
            navigate(`${process.env.PUBLIC_URL}/configuration/zone-list`);
        } else {
            toast.error(addZoneResponse.data.message || 'Something went wrong');
        }
        setLoading(false);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle="Add Zone" parent="Configuration" title="Zone" />
            <Card>
                <CardHeader className="pb-0">
                    <H3>Add Zone</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3">
                            <Col md='6'>
                                <Label className="form-label">Name <span className="requireStar">*</span></Label>
                                <input className="form-control" type="text" placeholder="Zone Name" {...register('name', { required: true })} />
                                <span className="text-danger">{errors.name ? 'Name is required' : ''}</span>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label">Countries <span className="requireStar">*</span></Label>
                                <Controller
                                    name="countries"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isMulti
                                            options={Country.getAllCountries()}
                                            getOptionLabel={(opt) => opt.name}
                                            getOptionValue={(opt) => opt.isoCode}
                                            value={selectedCountries}
                                            onChange={(items) => {
                                                setSelectedCountries(items);
                                                field.onChange(items);
                                            }}
                                        />
                                    )}
                                />
                                <span className="text-danger">{errors.countries ? errors.countries.message : ''}</span>
                            </Col>
                        </Row>
                        <br />
                        <button className="btn btn-primary" type="submit">Submit</button>
                        {/* <button className="btn btn-secondary ms-2" type="button" onClick={() => navigate(`${process.env.PUBLIC_URL}/configuration/zone-list`)}>Cancel</button> */}
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default ZoneForm;
